import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, Input, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { SiteMapUrl } from 'src/app/core/_enums/sitemap.url';
import { Family } from 'src/app/core/_models/family';
import { SpinnerOverlayService } from 'src/app/core/_services/spinner.overlay.service';
import { UserEntityService } from 'src/app/core/_services/user.entity.service';
import { StoreSelect, UpdateResourceAction } from 'src/app/store/actions/resource.actions';
import { AppState } from 'src/app/store/app.state';
import { DialogFusionUserEntityComponent } from '../../shared/dialog-fusion-user-entity/dialog-fusion-user-entity.component';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';

@Component({
  selector: 'app-list-user-entity',
  templateUrl: './list-user-entity.component.html',
  styleUrls: ['./list-user-entity.component.scss']
})
export class ListUserEntityComponent implements OnChanges {
  SiteMapUrl = SiteMapUrl;

  @Input() memberId!: string;

  treeControl = new NestedTreeControl<any>((node) => node.value);
  dataSource = new MatTreeNestedDataSource<any>();
  refItems!: any[];
  filteredData!: any[];

  constructor(
    private userEntityService: UserEntityService,
    private router: Router,
    private store: Store<AppState>,
    private spinnerService: SpinnerOverlayService,
    private dialog: MatDialog,
    private snackbarService: SnackbarService
  ) {}

  ngOnChanges(): void {
    this.getAll(this.memberId);
  }

  getAll(id: string) {
    this.spinnerService.show();
    this.userEntityService.getAll(id).subscribe(
      (arr) => {
        if (arr) {
          this.store.dispatch(new UpdateResourceAction(arr));
          this.store.select(StoreSelect.RESOURCES).subscribe((data) => {
            this.refItems = data;
            this.dataSource.data = data;
            let expandedNodes: any[] = [];
            if (this.treeControl.dataNodes) {
              expandedNodes = this.treeControl.dataNodes.filter((node) => this.treeControl.isExpanded(node));
            }
            this.treeControl.dataNodes = this.dataSource.data;
            this.treeControl.dataNodes.filter((dataNode) => expandedNodes.some((expandedNode) => dataNode.key == expandedNode.key)).map((node) => this.treeControl.expand(node));
          });
        }
        this.spinnerService.hide();
      },
      (error) => {
        this.snackbarService.open(SnackbarTypes.error);
        this.spinnerService.hide();
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  onClickNewItem() {
    this.router.navigate([`${SiteMapUrl.MenuUserEntity}/new`, 0], { state: { memberId: this.memberId } });
  }

  onClickFusionEu() {
    this.userEntityService.getAll(this.memberId).subscribe((listEu) => {
      const dialogRef = this.dialog.open(DialogFusionUserEntityComponent, {
        data: { listEu: listEu, memberId: this.memberId }
      });

      dialogRef.afterClosed().subscribe(async (newEu) => {
        let resp = await this.userEntityService.fusionEu(newEu);
        if (resp.length > 0) this.store.dispatch(new UpdateResourceAction(resp));
      });
    });
  }

  hasChild = (_: number, node: any) => !!node.key && node.key.length > 0;

  // Filtrer lors du changement du nom
  nameChanged(target: any) {
    let filteredData: any[] = [];

    if (target?.value?.length < 2) {
      this.dataSource.data = this.refItems;
      return;
    }

    let filteredParents = this.refItems.filter(
      (c) =>
        c.key?.toLowerCase().includes(target?.value?.toLowerCase()) ||
        c.value.some((x: { displayName: string }) => x.displayName.toLowerCase().includes(target?.value?.toLowerCase())) ||
        c.value.some((x: { code: string }) => x.code.toLowerCase().includes(target?.value?.toLowerCase()))
    );

    for (const parent of filteredParents) {
      let filteredChildren = parent.value.filter((v: { displayName: string; code: string }) => v.displayName.toLowerCase().includes(target?.value?.toLowerCase()) || v.code.toLowerCase().includes(target?.value?.toLowerCase()));
      var item = {
        key: parent.key,
        value: filteredChildren
      };
      filteredData.push(item);
    }

    this.dataSource.data = filteredData;
    this.treeControl.dataNodes = filteredData;
    this.treeControl.expandAll();
  }
}
